import React from "react"
import QuoteIcon from "../../assets/icons/quote.png"

const Testimonial = ({ testimonials }) => {

    const randomTestimonial = testimonials[Math.floor(Math.random()*testimonials.length)]

    const testimonial = randomTestimonial.testimonial

    return (
        <section className="testimonial">
            <div className="testimonial-content">
                <img alt="" src={ QuoteIcon }/>
                {testimonial.testimonial && (
                    <p className="testimonial-body">{testimonial.testimonial}</p>
                )}
                {testimonial.author && (
                    <p className="testimonial-author">-{testimonial.author}</p>
                )}
            </div>
        </section>
    )
}

export default Testimonial